import Vue from 'vue'
import Router from 'vue-router'

import {routerMode} from '@/config/env'

Router.prototype.goBack = function(toPath) {
  this.isBack = true
  if(! toPath) {
    window.history.go(-1)
  } else {
    window.location.href = toPath
  }
}

/**
 * 微信没有返回按钮
 */
window.addEventListener('popstate', function(e){
  Router.isBack = true
}, false)

Vue.use(Router)

export default new Router({
  mode: routerMode,
  routes: [
    {path: '/', component: resolve => require(['@/page/Main.vue'], resolve)},
    {path: '/home', component: resolve => require(['@/page/Main.vue'], resolve)},
    {path: '/article/:id?', name: 'article', component: resolve => require(['@/page/Article.vue'], resolve)},
    {path: '*', component: resolve => require(['@/components/Err.vue'], resolve)}
  ]
})
